export default {
	NAV_HEADER_ADD: 'Add Counting Area',
	NAV_HEADER_EDIT: 'Edit Counting Area',
	INPUT_TITLE_LABEL: 'Title',
	SWITCH_LABEL: 'Section Header or Counting Area',
	SWITCH_OPTION_1: 'Count Area',
	SWITCH_OPTION_2: 'Section Header',
	SAVE: 'Save'
};